import { CONTENT_TYPE, NAME_SOUND_ACTIVE, NAME_SOUND_HOVER, TYPE_QUESTIONS, useGameSounds } from '@educaplay/core';
import { Dialog } from "@educaplay/core/components";
import classes from './SingleQuestion.module.scss'
import { useState, useEffect, useRef } from 'react';
import LetterContainer from '../../LetterContainer';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import { TEST_SOUNDS } from '../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { AudioComponentControl } from '@educaplay/core/components/AudioComponentControl';
import { setAnimating } from '@educaplay/store/slices/gameSlice';
import { SCREENS } from '@educaplay/store/constants';

const ANSWER_DELAY = 1000;
export const SingleQuestion = (props) => {
    const gameSound = useGameSounds();
    const { question, onAnswer } = props;
    const [dialog, setDialog] = useState({
        open: false,
        source: null
    });

    const [selectedOption, setSelectedOption] = useState(() => question.answer?.answer ?? null);

    const [answersFeedback, setAnswersFeedback] = useState(null);
    const isExamMode = useSelector(state => state.game.examMode);
    const finishEntryAnimation = useSelector(state => state.game.isCompleteEntryAnimation)
    const [hasAnswered, setHasAnswered] = useState(false);
    const isAnimating = useSelector(state => state.game.isAnimating);
    const liveActived = useSelector(state => state.game.liveActived);
    const currentIndex = useSelector(state => state.game.currentIndex);
    const screen = useSelector(state => state.game.view);
    const dispatch = useDispatch();

    const questionsContainer = useRef();

    const answers = question.answers.map((answer) => {
        return {
            ...answer,
            className: answersFeedback?.[answer.id] ?? ''
        };
    });

    const sendUserAnswer = (userAnswer) => {
        if (!finishEntryAnimation || isAnimating || screen === SCREENS.SCORE_SCREEN) return;


        if (isExamMode) {
            onAnswer(userAnswer)
            return;
        }

        dispatch(setAnimating(true));

        const answerStyles = answers.reduce((acc, answer) => {
            const isUserAnswer = answer.id === userAnswer.answer;
            const userAnswerStyleValue = question.correctAnswers.includes(answer.id) ? classes.correct : classes.wrong
            return {
                ...acc,
                [answer.id]: isUserAnswer ? userAnswerStyleValue : '',
            }
        }, {});

        setTimeout(() => {
            setAnswersFeedback(answerStyles);
        }, (ANSWER_DELAY + 400));

        setTimeout(() => {
            onAnswer(
                userAnswer,
                {
                    showFeedback: !(question.checkAnswer(userAnswer) && !liveActived),
                    questionIndexAnswer: currentIndex
                })
        }, ANSWER_DELAY);
    }

    const handleHover = () => {
        gameSound.play(NAME_SOUND_HOVER);
    }

    const handleChangeSelection = (ev) => {
        if (!finishEntryAnimation) return;
        if (answersFeedback) return;
        if (dialog.open) return;
        if (!isExamMode && hasAnswered) return;

        if (!isExamMode) setHasAnswered(true);

        const { name: id } = ev.target;


        if (id === selectedOption) {
            gameSound.play(TEST_SOUNDS.DESELECT);
            const userAnswer = {
                type: TYPE_QUESTIONS.Selection,
                answer: null
            }
            setSelectedOption(null);
            sendUserAnswer(userAnswer);
            return;
        }

        isExamMode ? gameSound.play(NAME_SOUND_ACTIVE) : gameSound.play(TEST_SOUNDS.SUBMIT);
        setSelectedOption(id);

        const userAnswer = {
            type: TYPE_QUESTIONS.Selection,
            answer: id
        }

        sendUserAnswer(userAnswer);
    }

    useEffect(() => {
        questionsContainer.current.style.setProperty('--row-questions', question.answers.length);
        questionsContainer.current.style.setProperty('--desktop-row-questions', Math.ceil(question.answers.length / 2));
    }, [question])

    const variants = {
        initial: {
            // y: "-50%",
            opacity: 0
        },
        enter: {
            // y: "0%",
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.8
            }
        },
        exit: {
            // y: "0%",
            opacity: 0,
            transition: {
                type: 'tween',
                duration: 1.5
            }
        }
    };

    return (
        <>
            <Dialog open={dialog.open}
                onClose={() => {
                    setDialog({ open: false, source: null });
                }}
                variant="lightbox">
                <img src={dialog.source} alt="" />
            </Dialog>
            <AnimatePresence>
                <motion.div
                    className={classes.formContainer}
                    key={`question_${question.id}`}
                    variants={variants}
                    initial="initial"
                    animate="enter"
                    exit={{ y: '200%' }}
                >
                    <div className={classes.questionsContainer} ref={questionsContainer}>

                        {answers.map((answer, index) => (
                            <motion.div key={`answer_${index}`} className={clsx(classes.individualQuestion, answer.className)} variants={variants} onMouseEnter={handleHover} >
                                <label className={classes.clickableZone} >
                                    <input
                                        type="checkbox"
                                        name={answer.id}
                                        onChange={handleChangeSelection}
                                        className={classes.invisibleInput}
                                        checked={selectedOption === answer.id}
                                    />
                                    <LetterContainer index={index} />
                                    <div className={clsx(classes.contentContainer, selectedOption === answer.id && classes[`selected`], answer.className)}>
                                        {answer.type && (
                                            <div className={classes.multimediaContainer}>

                                                {answer.type === CONTENT_TYPE.IMAGE && (
                                                    <div className={clsx(classes.sourceMedia, classes.borderimg)}>
                                                        <img src={answer.source} onClick={(e) => { e.stopPropagation(); setDialog({ open: true, source: answer.source }) }} />

                                                    </div>
                                                )}

                                                {answer.type === CONTENT_TYPE.AUDIO && (
                                                    <div className={classes.sourceMedia}>
                                                        <AudioComponentControl source={answer.source} className={classes.audioComponent} />
                                                    </div>
                                                )}

                                            </div>

                                        )}
                                        {answer.answer && (
                                            <div className={clsx(classes.textContainer, classes.scrollbar)}>
                                                {answer.answer}
                                            </div>)}
                                    </div>
                                </label>

                            </motion.div>
                        ))}
                    </div >
                </motion.div>
            </AnimatePresence>
        </>
    );
}